import { Language } from '../../../../../../../types/language.enum'
import { DisclaimerLinks } from './disclaimer-links'

export const getLinkForLocale = (locale: Language): string =>
  DisclaimerLinks[locale]
